import React, { useEffect, useState } from 'react';
import { usePostDetail } from '../../hooks/post/usePostDetail';
import PreviewPostDialog from '../preview-post-dialog/preview-post-dialog.component';
import { IPostModel } from '../../models';
import { useNavigate } from 'react-router-dom';

export const PostDetailComponent = ({
  postId,
  onClose,
}: {
  postId: string;
  onClose?: () => void;
}) => {
  const { getDetailPost, postDetail } = usePostDetail({ shortId: postId });
  const navigate = useNavigate();

  useEffect(() => {
    getDetailPost(postId);
  }, [postId]);

  // useEffect(() => {
  //   if (!postDetail || !postDetail.id) navigate(`/`);
  // }, [postDetail]);

  // Route /share/post/:id → về trang chủ khi đóng. Khi mở inline (vd lịch sử donate)
  // truyền onClose để đóng tại chỗ, giữ nguyên trang đang xem.
  const handleClosePreview = () => {
    if (onClose) onClose();
    else navigate('/');
  };

  return postDetail?.id ? (
    <PreviewPostDialog
      visible={!!postDetail?.id}
      onclose={handleClosePreview}
      post={postDetail || ({} as IPostModel)}
      initialSlide={0}
    />
  ) : null;
};
